export const GRID_SCALE_DELAY = 400; // ms
export const PORTRAIT_SCROLL_MIN_LIMIT = 136; // px
export const SB_GAME_BOARD_HEIGHT = 35; // %
